import { useState } from 'preact/hooks';
import { CompositionPieView, PortfolioCompositionBars } from '../../components/overview';
import { BlockInfoIcon, Card, LoadingState, SegmentedControl } from '../../components/ui';
import { getOverviewBlockSubtitle, getOverviewBlockTitle } from '../../content';
import type { CompositionDimension, PortfolioCompositionData } from './types';

const COMPOSITION_TABS: { id: CompositionDimension; label: string }[] = [
  { id: 'location', label: 'Location' },
  { id: 'currency', label: 'Currency' },
  { id: 'operatingModel', label: 'Operating Model' },
];

interface OverviewAssetsSectionProps {
  composition: PortfolioCompositionData;
  loading?: boolean;
}

export function OverviewAssetsSection({ composition, loading }: OverviewAssetsSectionProps) {
  const [activeTab, setActiveTab] = useState<CompositionDimension>('location');

  const activeSlices = composition[activeTab];
  const usePieOnly = activeSlices.length > 0 && activeSlices.length < 3;

  return (
    <Card padding="flush" className="overview-composition-card">
      <header className="overview-composition-card__header">
        <div className="overview-composition-card__heading">
          <div className="overview-panel-card__title-row">
            <h2 className="overview-panel-card__title">
              {getOverviewBlockTitle('unitAssetsDistribution', 'Portfolio Composition')}
            </h2>
            <BlockInfoIcon blockId="unitAssetsDistribution" />
          </div>
          <p className="overview-panel-card__subtitle">
            {getOverviewBlockSubtitle('unitAssetsDistribution', 'Basis: Market Value')}
          </p>
        </div>
        <SegmentedControl
          className="overview-composition-card__tabs"
          ariaLabel="Portfolio composition basis"
          options={COMPOSITION_TABS}
          value={activeTab}
          onChange={setActiveTab}
        />
      </header>

      <div
        className={`overview-composition-card__body${
          usePieOnly ? ' overview-composition-card__body--pie-only' : ''
        }`}
      >
        <div className="overview-composition-card__pie">
          {loading ? (
            <LoadingState message="Loading composition…" />
          ) : (
            <CompositionPieView slices={activeSlices} labeled={usePieOnly} />
          )}
        </div>
        {!usePieOnly && (
          <div className="overview-composition-card__bars">
            <PortfolioCompositionBars slices={activeSlices} loading={loading} />
          </div>
        )}
      </div>
    </Card>
  );
}
